<template>
    <div>
        <vs-row>
            <vs-col vs-w="12">
                <template v-if="resource.synthesis_comment || Object.values(resource.synthesis_comment).length === 0">
                    <vs-row v-for="(fieldName, index) in resource.campaign_field.fields" :key="'comment-'+index" class="mb-20 mt-10">
                        <vs-col class="sm:w-1/5 w-full">
                    <span class="font-bold text-lg">
                        {{ fieldName.label }} :
                    </span>
                        </vs-col>
                        <vs-col class="sm:w-4/5 w-full">
                            <quill-editor
                                :value="resource.synthesis_comment[fieldName.label]"
                                :name="'synthesis_comment_'+index"
                                :options="options"
                                :disabled="false"
                                @input="debouncedInputHandleComment($event, fieldName.label)"
                            />
                        </vs-col>
                    </vs-row>
                </template>
                <template v-else>
                    <vs-row v-for="(fieldName, index) in Object.keys(resource.synthesis_comment)" :key="'comment-'+index" class="mb-20 mt-10">
                        <vs-col class="sm:w-1/5 w-full">
                    <span class="font-bold text-lg">
                        {{ fieldName }} :
                    </span>
                        </vs-col>
                        <vs-col class="sm:w-4/5 w-full">
                            <quill-editor
                                :value="resource.synthesis_comment[fieldName]"
                                :name="'synthesis_comment_'+index"
                                :options="options"
                                :disabled="false"
                                @input="debouncedInputHandleComment($event, fieldName)"
                            />
                        </vs-col>
                    </vs-row>
                </template>

                <Actions />

            </vs-col>
        </vs-row>
    </div>
</template>

<script>

import { quillEditor } from "vue-quill-editor";
import Actions from "../Actions.vue";

export default {
    components: {
        Actions,
        quillEditor,
    },
    props: {
        value: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            log: console.log,
            resource: {
                synthesis_comment: {}
            },
            options: {
                placeholder: "...",
                modules: {
                    toolbar: [
                        [{ size: ["small", false, "large"] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link", "image"]
                    ]
                }
            },
            debouncedInputHandleComment: _.debounce((value, fieldName) => {
                this.inputHandleComment(value, fieldName);
            }, 800)
        };
    },
    async created() {
        this.initResource();
        console.log('V1 Resource', window._.cloneDeep(this.resource))
    },
    computed: {},
    watch: {},
    methods: {
        initResource() {
            console.log('Value', window._.cloneDeep(this.value))
            let data = window._.cloneDeep(this.value)
            console.log('Data synthesis_comment', data.synthesis_comment)
            if (!data.synthesis_comment) data.synthesis_comment = {}

            data.campaign_field.fields.forEach(comment => {
                console.log('Nom du comment: ', comment)
                console.log('Valeur du comment', data.synthesis_comment[comment.label])
                if (!data.synthesis_comment[comment.label]) {
                    data.synthesis_comment[comment.label] = '';
                }
            })

            this.resource = data;
        },

        inputHandleComment(value, fieldName) {
            this.$set(this.resource.synthesis_comment, fieldName, value);

            return window
                .axios({
                    method: "put",
                    url: "/api/gestion/campaigns/update-comment/"+this.resource.id,
                    data: {
                        synthesis_comment: this.resource.synthesis_comment
                    }
                })
                .then(response => {
                    console.log('Update OK !')
                })
                .catch(err => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });

            //this.$emit('input', data);
        },
    }
};
</script>
<style scoped></style>
